import { Component, Input } from '@angular/core'


@Component({
    selector: 'app-global-spinner',
    standalone: true,
    templateUrl: './global-spinner.component.html',
    styleUrl: './global-spinner.component.scss',
    imports: [],
})
export class GlobalSpinnerComponent {
    @Input()
    messages: string[] = []
}
